// extracted by mini-css-extract-plugin
module.exports = {"background":"CheckoutSideCreditCard_background__OjCWT","headLine":"CheckoutSideCreditCard_headLine__hHLij","featuresList":"CheckoutSideCreditCard_featuresList__FYLod"};